import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import AboutUser from '../AboutUser/AboutUser.vue'
import ManageUser from '../manage.vue'
import GenerateLink from '../GenerateLink/GenerateLink.vue'
import BatchInstitutionAccess from '../BatchInstitutionAccess.vue'

export default {
  data: () => ({
    startDate: null,
    endDate: null,
    visible: false,
    totalItensOnPage: 0,
    dialog: false,
    editDialog: false,
    aboutDialog: false,
    dialogKey: false,
    generateLinkDialog: false,
    loading: false,
    userLoading: false,
    unidadeLoading: false,
    institutionLoading: false,
    expanded: [],
    users: [],
    selectedUsers: [],
    selectedUsersCache: {},
    selectAll: false,
    confirmActivateDialog: false,
    confirmDeactivateDialog: false,
    batchInstitutionDialog: false,
    institutionId: 0,
    institutions: [],
    unidadeId: 0,
    unidades: [],
    currentUser: {},
    userLogged: {},
    offices: [
      'Auxiliar',
      'Coordenador',
      'Enfermeiro',
      'Engenheiro',
      'Estagiario',
      'Recepcionista',
      'Supervisor',
      'Tecnico',
      'Farmaceutico',
      'Fisioterapeuta',
      'Administrativo',
      'Gerente',
      'Nutricionista',
    ],
    levels: [
      { text: 'Master', value: 0 },
      { text: 'Administrador', value: 1 },
      { text: 'Usuário', value: 2 },
    ],
    levelsAdmin: [
      { text: 'Supervisor', value: 2 },
      { text: 'Supervisor Principal', value: 8 },
      { text: 'Operador', value: 3 },
      { text: 'Coordenador Op.', value: 4 },
      { text: 'Coordenador Setor Assistencial', value: 5 },
      { text: 'Solicitador', value: 6 },
    ],
    levelsSupervisor: [
      { text: 'Supervisor', value: 2 },
      { text: 'Supervisor Principal', value: 8 },
      { text: 'Operador', value: 3 },
      { text: 'Coordenador Op.', value: 4 },
      { text: 'Coordenador Setor Assistencial', value: 5 },
      { text: 'Solicitador', value: 6 },
    ],
    status: ['Ativo', 'Inativo'],
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 10,
      name: null,
      email: null,
      userOffice: null,
      unidadeId: 0,
      institutionId: 0,
      userType: [],
      mainType: null,
      status: null,
      startDate: null,
      endDate: null,
      UserTypeLogged: null,
    },
    userName: null,
    userOffice: null,
    userEmail: null,
    userType: null,
    userStatus: null,
    error: false,
    show: false,
    message: '',
    headers: [
      {
        text: '',
        align: 'center',
        value: 'checkbox',
        sortable: false,
        width: 20,
      },
      {
        text: 'Nome',
        align: 'center',
        value: 'name',
      },
      {
        text: 'E-mail',
        align: 'center',
        value: 'email',
        sortable: false,
      },
      {
        text: 'Status',
        align: 'center',
        value: 'status',
        sortable: false,
      },
      {
        text: 'Nível no Sistema',
        align: 'center',
        value: 'mainType',
        sortable: false,
      },
      {
        text: 'Nível na instituição',
        align: 'center',
        value: 'institutions',
        sortable: false,
      },
      {
        text: 'Ultimo Acesso',
        align: 'center',
        value: 'lastLogin',
        sortable: false,
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
        width: 200,
      },
    ],
    headersMobile: [
      {
        text: '',
        align: 'center',
        value: 'checkbox',
        sortable: false,
        width: 50,
      },
      {
        text: 'Nome',
        align: 'center',
        value: 'name',
      },
      {
        text: 'Ações',
        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    institution: {},
  }),

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId =
      this.institution.userType < 2
        ? 0
        : JSON.parse(localStorage.getItem('institution')).id

    this.unidadeId =
      this.institution.userType > 2 && this.institution.userType != 8
        ? this.userLogged.unidadeId
        : 0

    this.searchUnidades()
    this.getInstitutions()
    this.updateTable()
  },

  components: {
    ManageUser,
    AboutUser,
    GenerateLink,
    BatchInstitutionAccess,
  },

  computed: {
    // Only Master (0) and Administrador (1) may link institutions in batch.
    canBatchLinkInstitutions() {
      return this.userLogged.mainType === 0 || this.userLogged.mainType === 1
    },

    // Reads from the cache instead of the current page, so a selection made
    // across different filters or pages keeps the name/e-mail of every user.
    selectedUsersData() {
      return this.selectedUsers
        .map((id) => this.selectedUsersCache[id])
        .filter((user) => user)
    },
  },

  methods: {
    isNumber(value) {
      return typeof value === 'number'
    },

    isInactive(value) {
      if (value.department) {
        return value.department.status == 1 ? 'departmentInactive' : ''
      }
      return 'departmentInactive'
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    unidadeName(value) {
      const unidade = this.unidades.find((unidade) => unidade.id === value)

      if (unidade) {
        return unidade.name
      } else {
        return 'Sem registro'
      }
    },

    institutionName(value) {
      const institution = this.institutions.find(
        (institution) => institution.id === value
      )

      if (institution) {
        return institution.name
      } else {
        return 'Sem registro'
      }
    },

    addUser() {
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    openGenerateLinkDialog() {
      this.generateLinkDialog = true
    },

    closeGenerateLinkDialog() {
      this.generateLinkDialog = false
    },

    editUser(user) {
      this.currentUser = user
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },

    deleteUser(user) {
      this.currentUser = user
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false
      this.aboutDialog = false

      this.updateTable()
    },

    openAbout(user) {
      this.currentUser = user
      this.dialogKey = !this.dialogKey
      this.aboutDialog = true
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize

      this.filter.name = this.userName
      this.filter.userOffice =
        this.userOffice != null ? this.offices.indexOf(this.userOffice) : null
      this.filter.email = this.userEmail
      this.filter.status = this.status.indexOf(this.userStatus)
      this.filter.userType = Array.isArray(this.filter.userType)
        ? this.filter.userType
        : this.filter.userType != null
        ? [this.filter.userType]
        : []

      // Datas para filtro conforme backend
      if (this.startDate) {
        // Envia como string ISO apenas a data (sem hora)
        this.filter.startDate = new Date(this.startDate)
          .toISOString()
          .substring(0, 10)
      } else {
        this.filter.startDate = null
      }
      if (this.endDate) {
        this.filter.endDate = new Date(this.endDate)
          .toISOString()
          .substring(0, 10)
      } else {
        this.filter.endDate = null
      }

      this.updateTable()
    },

    async exportToExcel() {
      // Prepare o filtro conforme necessário
      this.filter.institutionId = this.institutionId
      this.filter.unidadeId = this.unidadeId
      const exportFilter = {
        ...this.filter,
        userType: this.filter.userType.length ? this.filter.userType : null,
      }

      let now = new Date()
      const fileName = `Usuarios_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`

      // Chame o endpoint correto
      await this.apiService
        .post('user/exportExcel', exportFilter)
        .then((response) => {
          // O backend retorna o arquivo em base64
          var excelResult = `data:application/octet-stream;base64,${response}`
          const link = document.createElement('a')
          link.href = excelResult
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async searchUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async updateTable() {
      this.loading = true
      this.filter.unidadeId = this.unidadeId
      this.filter.institutionId = this.institutionId
      this.filter.UserTypeLogged = this.institution.userType
      const requestFilter = {
        ...this.filter,
        userType: this.filter.userType.length ? this.filter.userType : null,
        mainType: this.institution.userType >= 2 ? 2 : this.filter.mainType,
      }

      await this.apiService
        .post('user/list', requestFilter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.users = response.content.data

          this.totalItensOnPage = response.content.data.length
          this.totalItems = response.content.pager.totalItems
          this.loading = false
        })
    },

    reset() {
      this.institutionId =
        this.institution.userType < 2
          ? 0
          : JSON.parse(localStorage.getItem('institution')).id
      this.unidadeId =
        this.institution.userType > 2 && this.institution.userType != 8
          ? this.userLogged.unidadeId
          : 0
      this.userName = null
      this.userEmail = null
      this.userOffice = null
      this.userType = null
      this.userStatus = null
      this.filter = {
        page: 1,
        pageSize: this.pageSize,
        name: null,
        email: null,
        userOffice: null,
        unidadeId: 0,
        institutionId: 0,
        userType: [],
        mainType: null,
        status: null,
        startDate: null,
        endDate: null,
        UserTypeLogged: null,
      }
      this.updateTable()
    },

    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedUsers = this.users.map((user) => user.id)
      } else {
        this.selectedUsers = []
      }
    },

    async confirmActivate() {
      if (this.selectedUsers.length === 0) return

      try {
        await this.apiService.post('user/bulk-activate', this.selectedUsers)

        this.$toast.success('Usuarios ativados com sucesso')

        this.selectedUsers = []
        this.selectAll = false
        this.confirmActivateDialog = false
        this.updateTable()
      } catch (error) {
        this.$toast.error('Erro ao ativar usuários')
        this.confirmActivateDialog = false
      }
    },

    openBatchInstitutionDialog() {
      if (this.selectedUsers.length === 0) return

      this.dialogKey = !this.dialogKey
      this.batchInstitutionDialog = true
    },

    onBatchInstitutionSaved() {
      this.selectedUsers = []
      this.selectAll = false
      this.batchInstitutionDialog = false
      this.updateTable()
    },

    async confirmDeactivate() {
      if (this.selectedUsers.length === 0) return

      try {
        await this.apiService.post('user/bulk-deactivate', this.selectedUsers)

        this.$toast.success('Usuarios desativados com sucesso')

        this.selectedUsers = []
        this.selectAll = false
        this.confirmDeactivateDialog = false
        this.updateTable()
      } catch (error) {
        this.$toast.error('Erro ao desativar usuários')
        this.confirmDeactivateDialog = false
      }
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    selectedUsers(newVal) {
      this.selectAll =
        newVal.length === this.users.length && this.users.length > 0

      // Keeps the data of each user at the moment it was selected, since the
      // row leaves the table as soon as the filter or the page changes.
      const cache = {}
      newVal.forEach((id) => {
        const cached =
          this.selectedUsersCache[id] ||
          this.users.find((item) => item.id === id)
        if (cached) cache[id] = cached
      })
      this.selectedUsersCache = cache
    },
  },
}
